// import varCommon from '@/utils/varCommon'
import { Notification } from 'element-ui';

export default {
  methods: {
    // 显示小数点
    formatDecimalSeparator(number, decimals) {
      return Math.round(number * Math.pow(10, decimals)) / Math.pow(10, decimals);
    },
    // 显示千分位分隔符和小数点
    formatNumberWithCommasAndDecimalSeparator(number, decimals = 0) {
      let num = this.formatDecimalSeparator(number, decimals)
      return this.NumberWithCommas(num)
    },
    // 移除物件内有空的资料
    ObjectClean(obj) {
      for (var propName in obj) {
        if (obj[propName] === null || obj[propName] === undefined || obj[propName] === '') {
          delete obj[propName];
        }
      }
      return obj
    },
    // 增加会计符号格式化
    NumberWithCommas(x) {
      var parts = x.toString().split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    },
    /* 复制文字
     text 作为要复制的文本
     NotificMsg 如果有传则作为提示语(不直接显示复制的内容)
    */
    CopyTextToClipboard(text, NotificMsg) {
      if (!navigator.clipboard) {
        this.FallbackCopyTextToClipboard(text);
        return;
      }
      navigator.clipboard.writeText(text).then(function () {
        if (NotificMsg) {
          alert(`${NotificMsg}`);
        } else {
          alert(`已复制 ${text}`);
        }
      }, function (err) {
        Notification.error('复制失败: ', err);
      });
    },
    FallbackCopyTextToClipboard(text) {
      var textArea = document.createElement("textarea");
      textArea.value = text;

      // Avoid scrolling to bottom
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        var successful = document.execCommand('copy');
        var msg = successful ? '成功' : '失败';
        Notification.success(`复制${msg}`);
      } catch (err) {
        Notification.error('复制失败: ', err);
      }
      document.body.removeChild(textArea);
    },
    // 浮点数相加
    accAdd(arg1, arg2) {
      var r1, r2, m;
      try { r1 = arg1.toString().split(".")[1].length } catch (e) { r1 = 0 }
      try { r2 = arg2.toString().split(".")[1].length } catch (e) { r2 = 0 }
      m = Math.pow(10, Math.max(r1, r2));
      return (arg1 * m + arg2 * m) / m;
    },
    // 浮点数相减
    accSubtr(arg1, arg2) {
      var r1, r2, m, n;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) { r1 = 0 }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) { r2 = 0 }
      m = Math.pow(10, Math.max(r1, r2));
      n = (r1 >= r2) ? r1 : r2;
      return ((arg1 * m - arg2 * m) / m).toFixed(n);
    },
    // 浮点数相乘
    accMul(arg1, arg2) {
      if (arg1 !== undefined && arg2 !== undefined) {
        var m = 0;
        var s1 = arg1.toString();
        var s2 = arg2.toString();
        try {
          m += s1.split('.')[1].length;
        } catch (e) { () => { } }
        try {
          m += s2.split('.')[1].length;
        } catch (e) { () => { } }
        return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m);
      }
    },
    // 浮点数相除
    accDiv(arg1, arg2) {
      if (arg1 !== undefined && arg2 !== undefined) {
        var t1, t2, r1, r2;
        try {
          t1 = arg1.toString().split('.')[1].length;
        } catch (e) {
          t1 = 0;
        }
        try {
          t2 = arg2.toString().split('.')[1].length;
        } catch (e) {
          t2 = 0;
        }
        r1 = Number(arg1.toString().replace('.', ''));
        r2 = Number(arg2.toString().replace('.', ''));
        return this.accMul(r1 / r2, Math.pow(10, t2 - t1));
      }
    },
  }
}


// WEBPACK FOOTER //
// ./src/utils/methodCommon.js